<template>
<div>
	<xdetail></xdetail>
	<tohead></tohead>
</div>
</template>

<script>
	import xdetail from '../component/xdetail.vue';
	import tohead from '../component/tohead.vue';
	export default{
		components:{
			xdetail,
			tohead,
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// pdate.vue?0e4d2d8c